import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './MessengerScrollDownFab.css';
export type MessengerScrollDownFabProps = {
  /** Пользователь не у низа ленты */
  lifted: boolean;
  pendingCount: number;
  /** Показать подсказку «к ответу» при стриме, если новых «пузырей» ещё не считали */
  streamCue?: boolean;
  onClick: () => void;
  className?: string;
};

/** Кнопка «к низу» для агента и direct-чата: стекло, иконка, бейдж новых ниже. */
export function MessengerScrollDownFab({
  lifted,
  pendingCount,
  streamCue = false,
  onClick,
  className,
}: MessengerScrollDownFabProps) {
  if (!lifted) return null;

  const ariaLabel =
    pendingCount > 0
      ? `К новым сообщениям, непрочитанных ниже: ${pendingCount}`
      : streamCue
        ? 'К ответу'
        : 'К низу чата';

  return (
    <button
      type="button"
      className={['messengerScrollDownFab', className].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <ExpandMoreIcon className="messengerScrollDownFab__icon" aria-hidden />
      {pendingCount > 0 && (
        <span className="messengerScrollDownFab__badge messengerUnreadBadge">
          {pendingCount > 99 ? '99+' : String(pendingCount)}
        </span>
      )}
    </button>
  );
}
